/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const t=["horizontal","vertical","direct"];export{t as lengthDimensionMeasureType};
